/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_error__404__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Sie können`
};

const en_error__404__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `You can`
};

const es_error__404__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Puedes`
};

const fr_error__404__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Vous pouvez`
};

const it_error__404__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Puoi`
};

const nl_error__404__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `U kunt`
};

const pt_error__404__text_start = /** @type {(inputs: {}) => string} */ () => {
	return `Pode`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_start = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error__404__text_start(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error__404__text_start", locale)
	if (locale === "de") return de_error__404__text_start(inputs)
	if (locale === "en") return en_error__404__text_start(inputs)
	if (locale === "es") return es_error__404__text_start(inputs)
	if (locale === "fr") return fr_error__404__text_start(inputs)
	if (locale === "it") return it_error__404__text_start(inputs)
	if (locale === "nl") return nl_error__404__text_start(inputs)
	return pt_error__404__text_start(inputs)
};